<template>
	hello {{username}}
</template>

<script>
export default {
	props: ["username"]
}
</script>